/*!
 * Copyright (c) 2017-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import React,  { useState, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useOktaAuth } from '@okta/okta-react';
import { toRelativeUrl } from '@okta/okta-auth-js';
import { Outlet } from 'react-router-dom';
import Loading from './loading';
import SignInError from '../signInError/index'
import {updateUserInfo} from  '../../axios/index'
// import Loading from './Loading';

// export const RequiredAuth = () => {
//   const dispatch = useDispatch();
//   const { oktaAuth, authState } = useOktaAuth();
//   const userInfo = useSelector((state) => state.userInfo)

//   if (!authState || !authState?.isAuthenticated) {
//     const originalUri = toRelativeUrl(window.location.href, window.location.origin);
//     oktaAuth.setOriginalUri(originalUri);
//     oktaAuth.signInWithRedirect();
//     console.log("authInfo notAuthonticated 1")
//     return (<Loading />);
//   }

//   else{
//     console.log("authInfo authonticated 2")    
//     if(userInfo!==undefined &&  Object.keys(userInfo).length === 0 && Object.getPrototypeOf(userInfo) === Object.prototype){
//       console.log("authInfo getUserDetails 3")
 
//       oktaAuth.getUser().then((info) => {
//         console.log("authInfo userInfo 4", info)
      
//           if(info.sAMAccountName33!==undefined && info.Roles!==undefined && info.Roles.length>0){
//             console.log("authInfo userInfo 41", info)
      
//           // dispatch(updateUserInfo(info))   
//            console.log("authInfo userInfo 4a", info)      
//            return (<SignInError />);
//           }
//           else{           
//             //redirect to error page
//             console.log("authInfo errorInUpdatingUserInfo 5")
//             return (<SignInError />);
           
//             //alert("y")
//           }           
//         }).catch((err) => {
//           //redirect to error page
//           console.log("authInfo errorUnknown 6", err)
//           return (<Outlet />);
        
//       });
//      // alert("z")
//      console.log("authInfo errorUnknown 7")
     
//     }
//     else{
//       console.log("authInfo outlet  8", userInfo)
//      return (<Outlet />);
//     }
//     console.log("authInfo outlet  9", userInfo)
//     return (<Outlet />);
    
//   }
//   console.log("authInfo outlet  10", userInfo)
// }


export const RequiredAuth = () => {
  const { oktaAuth, authState } = useOktaAuth();

  useEffect(() => {
    if (!authState) {
      return;
    }

    if (!authState?.isAuthenticated) {
      const originalUri = toRelativeUrl(window.location.href, window.location.origin);
      oktaAuth.setOriginalUri(originalUri);
      oktaAuth.signInWithRedirect();
    }
  }, [oktaAuth, !!authState, authState?.isAuthenticated]);

  if (!authState || !authState?.isAuthenticated) {
    return (<Loading />);
  }

  return (<Outlet />);
}